import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { archivePlan } from './store/plans/actions';

import { Button } from 'components/ui/button';
import { Errors } from 'components/ui/errors';
import { requestErrors } from 'helpers/api_errors';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import Modal from 'components/modal';
import Options from 'components/form/managed_input/options';

export function ArchiveModal({ archivePlan, plan, plans, show, onHide }) {
  const [newPlanId, setNewPlanId] = useState(null);
  const [archiving, setArchiving] = useState(false);
  const [errors, setErrors] = useState([]);

  // Closes only once the plan is archived, so a refused archive says why and can be tried again.
  const handleArchive = async () => {
    setArchiving(true);
    setErrors([]);
    try {
      await archivePlan(plan, newPlanId === 'none' ? null : newPlanId);
    } catch (failure) {
      setErrors(requestErrors(failure, 'The plan could not be archived. Please try again.'));
      setArchiving(false);
      return;
    }
    setArchiving(false);
    onHide();
  };

  function reset() {
    setNewPlanId(null);
    setArchiving(false);
    setErrors([]);
  }

  // It can't be closed while archiving, so the answer always lands in the opening that asked.
  return (
    <Modal show={show} onHide={archiving ? null : onHide} onShow={reset}>
      <Modal.Header closeButton>
        Archive Plan
      </Modal.Header>
      <Modal.Body>
        <Errors className="mb-3" errors={errors} title={false} />
        <div className="form archive-modal">
          <p>Archiving this commission plan will do the following:</p>
          <ul>
            <li>Remove all current assignees</li>
            <li>Change the name of the plan to "<b>{plan.name} - Archived</b>"</li>
            <li>Update open vouchers currently set to this plan to the plan you select below</li>
          </ul>
          <ManagedFormGroup
            className="mb-2"
            includeBlank="Select a Plan"
            label="Update current vouchers to use this plan"
            required
            type="select"
            value={newPlanId}
            onValueChange={setNewPlanId}
          >
            <option value="none">No Plan</option>
            <Options
              labelName="name"
              options={plans.filter(p => !p.archived && p.id !== plan.id)}
              valueName="id"
            />
          </ManagedFormGroup>

          <small className="text-muted">Any users not assigned to this plan will be updated to “No Plan”</small>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={archiving} label="Cancel" variant="ghost" onClick={onHide} />
        <Button disabled={!newPlanId || archiving} label="Archive" variant="destructive" onClick={handleArchive} />
      </Modal.Footer>
    </Modal>
  );
}

ArchiveModal.propTypes = {
  archivePlan: PropTypes.func.isRequired,
  plan: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  plans: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  })).isRequired,
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  plans: state.plans,
});

const mapDispatchToProps = {
  archivePlan,
};

export default connect(mapStateToProps, mapDispatchToProps)(ArchiveModal);
